<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-7 my-4" style="color:#AF8936">
      <h2 class="hidden-sm-and-down">Consultar Partes</h2>
      <div class="flex-grow-1"></div>
      <v-btn v-if="roleUser === 1 || roleUser === 3" class="mx-5" dark small color="blue lighten-1" style="margin-left: -6px;" to="/oficialia">Validar Cédula</v-btn>
      <!-- <v-btn class="mx-5" dark small color="blue lighten-1" style="margin-left: -6px;" to="/tocas">Ver Tocas</v-btn> -->
      <v-dialog v-model="dialog" max-width="500px" persistent>
        <!-- <template v-slot:activator="{ on }">
          <v-btn v-if="roleUser <= 1" dark small  color="blue lighten-1" style="margin-left: -6px;" v-on="on">Agregar Parte</v-btn>
        </template> -->

        <!--<v-btn slot:activator="{on}" color="grey darken-2" dark class="mb-2">Nuevo</v-btn>-->
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>

          </v-card-title>
          <v-card-text>

            <v-container grid-list-md>
              <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.nombre" label="Nombre(s)" :rules="notBlankRules" :disabled="editedIndex > -1">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.primer_apellido" label="Primer Apellido" :rules="notBlankRules" :disabled="editedIndex > -1"></v-text-field>
                  </v-flex xs12>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.segundo_apellido" label="Segundo Apellido" :disabled="editedIndex > -1">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.num_cedula" label="Cédula" :disabled="editedIndex > -1">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="tiposCedulas"
                      item-text="nombre"
                      item-value="id"
                      label="Tipo Cédula"
                      persistent-hint
                      v-model.trim="editedItem.tipo_cedula"
                      :disabled="editedIndex > -1"
                      :rules="[v => !!v || 'Seleccione una opción']"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.email" label="Email Civil" :rules="emailRules">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.email_penal" label="Email Penal" :rules="emailRules">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.celular" label="Celular" :rules="notBlankRules" :disabled="editedIndex > -1">
                    </v-text-field>
                  </v-flex>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" dark @click.native="close">Cancelar</v-btn>
                    <v-btn v-if="editedIndex > -1" color="yellow darken-2" @click.native="editParte(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                    <v-btn v-else color="yellow darken-2" @click.native="addParte(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                  </v-card-actions>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog><!-- end dialog edit o save-->
    </v-card-title>

    <v-form class="mx-10">
      <v-card flat>
        <!-- <v-toolbar color="grey" dark dense flat>
          <h3>Consulta de Partes</h3>
        </v-toolbar> -->
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="nombre"
                label="Nombre(s)"
                prepend-icon="mdi-account"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="primer_apellido"
                label="Primer Apellido"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="segundo_apellido"
                label="Segundo Apellido"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-text-field>
            </v-col>
          </v-row>
          <!-- <v-divider vertical></v-divider> -->
          <v-row
            justify="center"
          >
            <v-col cols="12" md="4">
              <v-text-field
                v-model="email"
                label="Email"
                prepend-icon="mdi-card-text-outline"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="num_toca"
                label="Toca"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-text-field>
            </v-col>
            <v-col v-if="roleUser <= 1" rolecols="12" md="4">
              <v-select
                :items="salasList"
                v-model="sala"
                label="Sala"
                item-value="id"
                item-text="nombre"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-select>
            </v-col>
          </v-row>

          <v-btn block color="primary" @click="clickSearch()" class="my-5">
            Buscar
          </v-btn>
        </v-card-text>
      </v-card>
      <v-divider></v-divider>
      <v-card>
        <div v-if="showAlert">
          <v-alert
            prominent
            outlined
            type="error"
           >
            <v-row align="center">
              <v-col class="grow hidden-xs-only">No se encontraron registros relacionados con la busqueda.</v-col>
              <v-col class="grow hidden-sm-and-up">No hay registros.</v-col>
              <!-- <v-col class="shrink" >
                <v-btn dark small  color="teal" style="margin-left: -6px;"  @click="agregarParte(item)">Agregar Parte</v-btn>
              </v-col> -->
            </v-row>
          </v-alert>
        </div>
          <template>
            <v-card-title  style="color:#AF8936">
              <h5>{{ titleTabla }}</h5>
            </v-card-title>
            <v-data-table
              :loading="loadingTable"
              hide-default-footer
              :headers="headers"
              :items="resultPartes"
              item-key="id"
              hide-overlay
              disable-pagination
            >
              <template v-slot:item.action="{ item }">
                <div class="text-center">
                <v-btn v-if="roleUser === 1 || roleUser === 3" class="mx-2" icon color="orange lighten-2" @click="editItem(item)">
                  <v-icon>mdi-account-edit</v-icon>
                </v-btn>
                <!-- <v-btn v-if="roleUser === 1 || roleUser === 3" class="mx-2" icon color="red" @click="deleteParte(item)"> -->
                  <!-- <v-icon>mdi-delete</v-icon> -->
                <!-- </v-btn> -->
                 <v-btn class="mx-2" dark x-small  color="blue lighten-1" style="margin-left: -6px;" @click="showTocas(item)">
                   TOCAS
                </v-btn>
              <!-- <v-btn v-if="roleUser <= 4" class="mx-2" dark x-small  color="blue lighten-1" style="margin-left: -6px;" @click="AgregarToca(item)">
                AGREGAR TOCA
              </v-btn> -->
            </div>
              </template>
              <template v-slot:item.tipo_cedula="{ item }">
                {{ item.tipo_cedula == 1 ?  'Estatal' : 'Federal' }}
              </template>
              <template v-slot:item.email="{ item }">
              <div>
                <b>Civil:</b> {{ item.email }}
              </div>
              <div>
                <b>Penal:</b> {{ item.email_penal}}
              </div>
              </template>
            </v-data-table>
          </template>

          <v-overlay :value="overlay">
             <v-progress-circular indeterminate size="64"></v-progress-circular>
           </v-overlay>

      </v-card>
    </v-form>
    <br>

      <v-dialog v-model="dialog2" max-width="500px" persistent>
        <!--<v-btn slot:activator="{on}" color="grey darken-2" dark class="mb-2">Nuevo</v-btn>-->
        <v-card>
          <v-card-title>
            <span class="headline">Agregar Toca</span>

          </v-card-title>
          <v-card-text>

            <v-container grid-list-md>
              <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="toca" label="Numero de Toca" :rules="tocaRules">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-if="roleUser <= 3"
                      :items="salasList"
                      v-model="sala_id"
                      label="Sala"
                      item-value="id"
                      item-text="nombre"
                      :rules="notBlankRules"
                      >
                    </v-select>
                    <!-- <v-text-field v-model="toca" label="Numero de Toca" :rules="notBlankRules">
                    </v-text-field> -->
                  </v-flex>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" dark @click.native="close_toca">Cancelar</v-btn>
                    <v-btn color="yellow darken-2" @click.native="addToca()" :loading="loading" class="white--text">Guardar</v-btn>
                  </v-card-actions>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog><!-- end dialog edit o save-->

  </v-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');
  import { VueEditor } from "vue2-editor";
  export default {
    data: () => ({
      nombre: '',
      primer_apellido: '',
      segundo_apellido: '',
      email: '',
      sala_id: '',
      sala:'',
      acuerdos_sala:'',
      toca: '',
      num_toca: '',
      overlay:false,
      parte:[],
      salasList:[],
      ncompleto:'',
      showTabla: false,
      showAlert: false,
      dialog: false,
      dialog2: false,
      // dialog3: false,
      loading:false,
      valid: true,
      titleTabla: 'ÚLTIMOS REGISTROS:',
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Primer Apellido', value: 'primer_apellido' },
        { text: 'Segundo Apellido', value: 'segundo_apellido' },
        { text: 'Cédula', value: 'num_cedula', sortable: false },
        { text: 'Tipo', value: 'tipo_cedula', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      loadingTable: false,
      editedIndex: -1,
      editedItem: {
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        num_cedula:'',
        tipo_cedula:'',
        email:'',
        email_penal:'',
        celular: '',
        validada: 1
      },
      defaultItem: {
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        num_cedula:'',
        tipo_cedula:'',
        email:'',
        email_penal:'',
        celular: '',
        validada: 1
      },
      tiposCedulas: [
        { id: 1, nombre: "Estatal" },
        { id: 2, nombre: "Federal" }
      ],
      // notificacion:{
      //   asunto:'',
      //   contenido:'',
      // },
      // DefaultNotificacion:{
      //   asunto:'',
      //   contenido:'',
      // },
      listNotificaciones:[],
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      tocaRules: [
        v => !!v || 'El campo es requerido',
        v => /^\d*(\/)(\d{4})[-]?(\w+)?/.test(v) || 'Ingrese formato valido',
      ],
      emailRules: [
        v => !!v || 'El campo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingrese un correo válido',
      ]
    }),
    computed: {
      ...mapGetters([
        "resultPartes", "dataNotFound", "roleUser", "currentUser", "token_"
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Parte' : 'Editar Parte'
      },
    },
    mounted(){
      this.buscarParte()
      this.getSalas();
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    methods: {
      clickSearch(){
        this.titleTabla = 'RESULTADO DE LA BÚSQUEDA:'
        this.loadingTable = true
        this.buscarParte()
      },
      AgregarToca(item){
        this.dialog2 = true
        this.parte = item
      },
      buscarParte() {
        this.overlay = true
        this.$store.dispatch("CONSULTAR_PARTES", {
          nombre: this.nombre,
          primer_apellido: this.primer_apellido,
          segundo_apellido: this.segundo_apellido,
          email: this.email,
          toca: this.num_toca,
          sala: this.sala,
          validada: 1
        })
        .then((response) => {
          this.overlay = false
          this.loadingTable = false
           //console.log(response.data);
          if (response.data.status == 'ok') {
            this.showTabla = true
            this.showAlert = false
          } else {
            this.showAlert = true
            this.showTabla = false
          }
        })
        .catch(err => {
          this.overlay = false
          //console.log(err);
          this.showAlert = true
          this.showTabla = false
        });
      },
      mostrarParte(item){
        this.$router.push('/partes/show/' + item.id )
      },
      editItem (item) {
        this.editedIndex = this.resultPartes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      addParte(){
        if (this.$refs.form.validate()) {
          this.loading = true;
          var data = this.editedItem;
          this.$store
            .dispatch("SAVE_PARTES",data)
            .then((response) => {
              //console.log(response.message);
              this.close ();
              Swal.fire({
                icon: 'success',
                title: 'Se Guardó Correctamente',
                showConfirmButton: false,
                timer: 1500
              })
              this.buscarParte();
            })
            .catch(error => {
              //console.log(error);
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: error.response.data,
                  showConfirmButton: false,
                  timer: 1500
                })
              //this.showAlert(this.notification);
            });
          this.loading = false;
        }
      },
      editParte(item){
        if (this.$refs.form.validate()) {
          this.loading = true;
          //console.log("store",item);
          this.$store
            .dispatch("EDIT_PARTE",item)
            .then((response) => {
              this.dialog=false;
              Swal.fire({
                icon: 'success',
                title: 'Actualizado Correctamente',
                showConfirmButton: false,
                timer: 1500
              })
              this.buscarParte();
              //this.roles = response.data;//usar response para datos, se puede usar getters
            })
            .catch(err => {
              console.log(err);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err.response.data.status,
                showConfirmButton: false,
                timer: 1500
              })
              //this.showAlert(this.notification);
            });
          this.loading = false;
        }
      },
      deleteParte(item){
        confirm('Seguro de eliminar el usuario?') &&
        //console.log("store",item.id);
        //var data = this.$data;
        this.$store
          .dispatch("DELETE_PARTE",item.id)
          .then((response) => {
            Swal.fire({
              icon: 'success',
              title: 'Se Eliminó Correctamente',
              showConfirmButton: false,
              timer: 1500
            })
            this.buscarParte();
          })
          .catch(err => {
            console.log(err);
            //this.showAlert(this.notification);
          });
      },

      getSalas() {
        this.$store
          .dispatch("GET_SALAS")
          .then((response) => {
            this.salasList = response.data.salas;//usar response para datos, se puede usar getters
            //console.log(response);
          })
          .catch(err => {
            console.log(err);
            //this.showAlert(this.notification);
          });
      },

      addToca(){
        if (this.$refs.form.validate()) {
          this.loading = true;
          if(this.roleUser === 4){
            this.acuerdos_sala = this.currentUser.sala;
          }else{
            this.acuerdos_sala = this.sala_id
          }
          //var data = this.editedItem;
          //console.log(this.parte);
          this.$store
            .dispatch("SAVE_TOCAS_P",{
              parte_id: this.parte.id,
              toca_identificador: this.toca,
              sala: this.acuerdos_sala
            })
            .then((response) => {
              console.log(response);
              this.close ();
              Swal.fire({
                icon: 'success',
                title: 'Se Guardó Correctamente',
                showConfirmButton: false,
                timer: 1500
              })
              this.buscarParte();
            })
            .catch((error) => {
              //console.log(error);
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: error.response.data.message,
                  showConfirmButton: false,
                  timer: 1500
                })
              //this.showAlert(this.notification);
            });
            this.dialog2 =false;
          this.loading = false;
        }
      },
      showTocas(item){
        this.$router.push({
           name: 'PartesTocas',
           params: { parte_id: item.id }
           })
      },
      validate () {
        this.$refs.form.validate()
      },
      close_toca () {
        this.dialog2 = false
        setTimeout(() => {
          this.$refs.form.reset()
          this.dialog2 = false
        }, 300)
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.$refs.form.reset()
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.dialog = false
        }, 300)
      },
    }
  };
</script>
